import {
  ApolloLink,
  Operation,
  NextLink,
  FetchResult,
  fromPromise,
} from '@apollo/client'
import { Observable } from '@apollo/client/utilities'

export const loadCacheIntegrityDebuggerModule = async () =>
  (await import('./CacheIntegrityDebugger')).CacheIntegrityDebugger

class CacheIntegrityDebuggerLink extends ApolloLink {
  // We only need one property to cache the loading promise.
  private loaderPromise: Promise<any> | null = null

  // This function now simply ensures the loading process is started only once.
  private ensureLoaded(): Promise<any> {
    if (!this.loaderPromise) {
      this.loaderPromise = loadCacheIntegrityDebuggerModule()
    }
    return this.loaderPromise
  }

  public request(
    operation: Operation,
    forward: NextLink
  ): Observable<FetchResult> {
    return fromPromise(this.ensureLoaded()).flatMap(() => {
      return forward(operation)
    })
  }
}

export const cypressCacheIntegrityDebuggerLink = window.Cypress
  ? new CacheIntegrityDebuggerLink()
  : null
